import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueueFoundEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from '.'

export const queueFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        queue_id,
        ...properties
    } = extractProperties<NinchatQueueFoundEvent>(action.payload)

    if ((state.user_id ?? '') in (properties.queue_members ?? {})) {
        state.user_queues ??= {}

        state.user_queues[queue_id] = properties
    } else {
        state._queues ??= {}

        state._queues[queue_id] = properties
    }
}
